/**
 * LocationInformationSection Component
 * Handles address-related fields: country, state, city, address, postal code, mobile number
 */

import React from "react";
import { ThreeDots } from "react-loader-spinner";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import location from "../../../../../images/icons/location.svg";
import PostalCode from "../../../../../images/icons/postal-code.svg";
import Tele from "../../../../../images/icons/tele.svg";

const LocationInformationSection = ({
  isLoading,
  fieldErrors = {},
  clearFieldError,
  country,
  setCountry,
  countryDropdownOpen,
  setCountryDropdownOpen,
  countryDropdownRef,
  handleToggleCountryDropdown,
  handleCountryChange,
  countriesList,
  countrySearchTerm,
  handleCountrySearchInputChange,
  filteredCountries,
  state,
  setState,
  stateDropdownOpen,
  setStateDropdownOpen,
  stateDropdownRef,
  stateSearchTerm,
  setStateSearchTerm,
  handleStateSearchInputChange,
  filteredStates,
  states,
  city,
  setCity,
  address,
  setAddress,
  postCode,
  setPostCode,
  mobileNo,
  setMobileNo,
}) => {
  return (
    <div className="information-inner">
      <div className="information">
        <div className="information-title">
          Address
        </div>
        <div className="information-outer">
          <div className="information-left">
            <div className="inner-detail-outer" id="field-country">
              <div className="inner-detail">
                <span className="icon">
                  <img src={location} alt="Location Icon" />
                </span>
                <div className="inner-detail-inner">
                  <label>Country *</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <ThreeDots
                    height="18"
                    width="20"
                    radius="9"
                    color="#6479f9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${countryDropdownOpen ? 'open' : ''}${fieldErrors.country ? ' field-error' : ''}`} ref={countryDropdownRef}>
                      <div className="selected-option custom-dropdown-user-new" onClick={() => { handleToggleCountryDropdown(); clearFieldError?.('country'); }} >
                        {country ? countriesList.find((c) => c.country === country)?.country : 'Select Country'}
                      </div>
                      {countryDropdownOpen && (
                        <div className="custom-dropdown-new">
                          <input
                            type="text"
                            className="search-bar"
                            placeholder="Search..."
                            value={countrySearchTerm}
                            onChange={handleCountrySearchInputChange}
                          />
                          <ul className="country-list">
                            {filteredCountries.length > 0 &&
                              filteredCountries.map((c) => (
                                <li
                                  key={c.country}
                                  className={country === c.country ? 'selected-item' : ''}
                                  onClick={() => handleCountryChange(c.country)}
                                >
                                  {c.country}
                                </li>
                              ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {states.length > 0 && (
              <div className="inner-detail-outer">
                <div className="inner-detail">
                  <span className="icon">
                    <img src={location} alt="Location Icon" />
                  </span>
                  <div className="inner-detail-inner">
                    <label>State *</label>
                  </div>
                </div>
                <div className="inner-detail">
                  <span className="icon"></span>
                  {isLoading ? (
                    <ThreeDots
                      height="18"
                      width="20"
                      radius="9"
                      color="#6479f9"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{}}
                      wrapperClassName=""
                      visible={true}
                    />
                  ) : (
                    <div className="inner-detail-inner">
                      <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${stateDropdownOpen ? 'open' : ''}`} ref={stateDropdownRef}>
                        <div className="selected-option custom-dropdown-user-new"
                          onClick={() => {
                            setStateDropdownOpen(!stateDropdownOpen);
                            setStateSearchTerm('');
                          }}
                          style={{ cursor: 'pointer' }}
                        >
                          {state ? states.find((s) => s.state === state)?.state : 'Select State'}
                        </div>
                        {stateDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <input
                              type="text"
                              className="search-bar"
                              placeholder="Search..."
                              value={stateSearchTerm}
                              onChange={handleStateSearchInputChange}
                            />
                            <ul className="state-list">
                              {filteredStates.length > 0 &&
                                filteredStates.map((s) => (
                                  <li
                                    key={s.state}
                                    className={state === s.state ? 'selected-item' : ''}
                                    onClick={() => {
                                      setState(s.state);
                                      setStateDropdownOpen(false);
                                    }}
                                  >
                                    {s.state}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="inner-detail-outer" id="field-city">
              <div className="inner-detail">
                <span className="icon">
                  <img src={location} alt="Location Icon" />
                </span>
                <div className="inner-detail-inner">
                  <label>City *</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <ThreeDots
                    height="18"
                    width="20"
                    radius="9"
                    color="#6479f9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <input type="text" id="city" value={city} onChange={(e) => { setCity(e.target.value); clearFieldError?.('city'); }} required className={fieldErrors.city ? 'field-error' : ''} />
                  </div>
                )}
              </div>
            </div>

            <div className="inner-detail-outer" id="field-address">
              <div className="inner-detail">
                <span className="icon"><img src={location} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label htmlFor="address">Address *</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <ThreeDots
                    height="18"
                    width="20"
                    radius="9"
                    color="#6479f9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <input type="text" id="address" value={address} onChange={(e) => { setAddress(e.target.value); clearFieldError?.('address'); }} rows="4" required className={fieldErrors.address ? 'field-error' : ''} />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="information-right">
            <div className="inner-detail-outer">
              <div className="inner-detail">
                <span className="icon"><img src={PostalCode} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label htmlFor="postal_code">Postal Code </label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <ThreeDots
                    height="18"
                    width="20"
                    radius="9"
                    color="#6479f9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <input type="text" id="postal_code" value={postCode} onChange={(e) => setPostCode(e.target.value)} />
                  </div>
                )}
              </div>
            </div>
            <div className="inner-detail-outer" id="field-mobileNo">
              <div className="inner-detail">
                <span className="icon"><img src={Tele} alt="type" /></span>
                <div className="inner-detail-inner">
                  <label htmlFor="number">Mobile No. *</label>
                </div>
              </div>
              <div className="inner-detail">
                <span className="icon"></span>
                {isLoading ? (
                  <ThreeDots
                    height="18"
                    width="20"
                    radius="9"
                    color="#6479f9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                ) : (
                  <div className="inner-detail-inner">
                    <PhoneInput
                      placeholder="Enter phone number"
                      value={mobileNo}
                      onChange={(val) => { setMobileNo(val); clearFieldError?.('mobileNo'); }}
                      className={fieldErrors.mobileNo ? 'field-error' : ''}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationInformationSection;
